import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { get } from 'lodash'
import { LogCard } from 'components/sections/activity'
import {
  ElevatedButton,
  FixedRightBottom,
  Logs,
  Placeholders
} from 'components/layout'
import { LogDetail } from 'components/sections/dashboard'
import { ACTIVITY_SECTIONS, ACTIVITY_STATES, CONFIGURATION_KEYS, ROLES } from 'constants/enums'
import { SignOff } from 'containers/forms/dashboard'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import modals from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import AcceptActivity from '../../forms/dashboard/AcceptActivity/AcceptActivity'
import { getSignupRole } from '../../../utils/token'
import { connect } from 'react-redux'
import { apiConfiguration } from '../../../helpers/decorators/api'

const logSchema = journey => ({
  description: get(journey, 'observations'),
  date: get(journey, 'endDate'),
  category: get(journey, 'activityCategory.translatedName'),
  fileUrls: get(journey, 'fileUrls')
})

@injectIntl
@apiConfiguration()
@connect(({ auth, apiV2 }) => ({
  user: auth.user,
  configuration: apiV2.configuration
}))
@modal.trigger()
class RPReportAssessor extends Component {
  static propTypes = {
    params: PropTypes.object,
    onOpen: PropTypes.func,
    residentialProject: PropTypes.object,
    intl: PropTypes.object,
    user: PropTypes.object,
    configuration: PropTypes.object.isRequired
  }

  componentWillMount = async() => {
    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id, get(this.props, 'residentialProject.assessor.organization.i'), true)
  }

  componentWillReceiveProps = async(nextProps) => {
    if (get(this.props, 'residentialProject.assessor.organization.id') !== get(nextProps, 'residentialProject.assessor.organization.id')) {
      await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id, get(nextProps, 'residentialProject.assessor.organization.id'), true)
    }
  }

  handleOpenSignOff = () => this.props.onOpen(modals.SIGN_OFF)
  handleOpenLogDetail = () => this.props.onOpen(modals.LOG_DETAIL)
  handleOpenAcceptActivity = () => this.props.onOpen(modals.ACCEPT_ACTIVITY)

  render() {
    const { residentialProject, params, intl, user } = this.props

    const setup = get(residentialProject, 'isAcceptedByAssessor') === false
      && get(residentialProject, 'state.value') === ACTIVITY_STATES.in_progress.id
      && getSignupRole(user) === ROLES.ASSESSOR.u

    const signoffable =
      get(residentialProject, 'state.value') ===
        ACTIVITY_STATES.assessment.id &&
      get(residentialProject, 'isAssessmentPositive') === false
    const RP_SECTION = ACTIVITY_SECTIONS.residential_project.id
    const colorClass = getActivityClassName(RP_SECTION)
    const noReportText = intl.formatMessage({
      id: 'label.waiting_for_participant_report',
      defaultMessage: 'Waiting for participant to submit their report.'
    })

    const isAssessorReportAdditionalInfoEnabled = get(this.props, `configuration.values.${CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id}.booleanValue`)

    return (
      <Logs.Wrap>
        {get(residentialProject, 'observations') ? (
          <Logs.Item>
            <LogCard
              log={logSchema(residentialProject)}
              activitySection={RP_SECTION}
              onOpenDetail={this.handleOpenLogDetail}
              variableHeight
            />
          </Logs.Item>
        ) : (
          <Placeholders.LogsPlaceholder customMessage={noReportText} />
        )}

        {signoffable && (
          <FixedRightBottom>
            <ElevatedButton
              onClick={this.handleOpenSignOff}
              colorClass={colorClass}
              intlKey="button.sign_off_dashed"
              high
              large
              oval
              uppercase
            >
              Sign off
            </ElevatedButton>
          </FixedRightBottom>
        )}
        {setup &&
        <FixedRightBottom>
          <ElevatedButton
            onClick={this.handleOpenAcceptActivity}
            colorClass={colorClass}
            intlKey="label.accept_becoming_assessor"
            high
            large
            oval
            uppercase
          >
            Become the assessor
          </ElevatedButton>
        </FixedRightBottom>}
        {signoffable && (
          <SignOff
            activitySection={RP_SECTION}
            colorClass={colorClass}
            id={params.rpId}
            modalId={modals.SIGN_OFF}
            actionId={get(
              residentialProject,
              'residentialProjectAssessmentRequestActionId'
            )}
            isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
            isRpRequest
          />
        )}
        {setup &&
        <AcceptActivity
          colorClass={colorClass}
          id={params.rpId}
          modalId={modals.ACCEPT_ACTIVITY}
          isRpRequest
        />}
        <LogDetail
          modalId={modals.LOG_DETAIL}
          colorClass={colorClass}
          editable={false}
          log={{
            description: get(residentialProject, 'observations'),
            fileUrls: get(residentialProject, 'fileUrls'),
            date: get(residentialProject, 'endDate')
          }}
        />
      </Logs.Wrap>
    )
  }
}

export default RPReportAssessor
